import { render } from "./Agent-item.vue?vue&type=template&id=ffcb3de4&scoped=true"
import script from "./Agent-item.vue?vue&type=script&lang=js"
export * from "./Agent-item.vue?vue&type=script&lang=js"

import "./Agent-item.vue?vue&type=style&index=0&id=ffcb3de4&scoped=true&lang=css"

import exportComponent from "/root/fixed-links/crm-updated/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffcb3de4"]])

export default __exports__